import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserAuthenticationService } from '../services/user-authentication.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private userAuthenticationService: UserAuthenticationService,
  ) {}

  canActivate(): boolean {
    if (this.userAuthenticationService.isUserAuthenticated) {
      this.router.navigate(['/users']);
      return false;
    }
    return true;
  }
}
